import AdsClickOutlined from '@mui/icons-material/AdsClickOutlined';
import EmojiEventsOutlined from '@mui/icons-material/EmojiEventsOutlined';
import PresentToAllOutlined from '@mui/icons-material/PresentToAllOutlined';
import TouchAppOutlined from '@mui/icons-material/TouchAppOutlined';
import TrackChanges from '@mui/icons-material/TrackChanges';
import VisibilityOutlined from '@mui/icons-material/VisibilityOutlined';
import { OpenXAgentHandCoinsIcon } from '../../../icons/OpenXAgentHandCoinsIcon.tsx';
import type { OpenXAgentMatchedDomainApp, OpenXAgentMatchedDomainAppPanelData } from './types.ts';

const DAILY_HEART = { name: 'dailyhearthandhome.com', spend: '$48.4K', marketRequest: '11.6M/mo', relevance: '89%' };
const PANTRY_AND_PROVISIONS = {
  name: 'pantryandprovisionsorevenlongerdomainname.com',
  spend: '$5.4K',
  marketRequest: '2.8M/mo',
  relevance: '81%',
};
const ONET = { name: 'onet.pl', spend: '$67.3K', marketRequest: '21.9M/mo', relevance: '79%' };

const MOCK_DOMAIN_APPS: OpenXAgentMatchedDomainApp[] = [
  { ...DAILY_HEART, isDirect: true },
  { ...PANTRY_AND_PROVISIONS, isDirect: false },
  { ...ONET, isDirect: false },
  { ...DAILY_HEART, isDirect: false },
  { ...PANTRY_AND_PROVISIONS, isDirect: false },
  { ...ONET, isDirect: true },
  { ...DAILY_HEART, isDirect: false },
  { ...PANTRY_AND_PROVISIONS, isDirect: false },
  { ...ONET, isDirect: false },
  { ...DAILY_HEART, isDirect: false },
  { ...PANTRY_AND_PROVISIONS, name: 'domainname.com', isDirect: true },
  { ...ONET, isDirect: false },
  { ...DAILY_HEART, isDirect: false },
  { ...PANTRY_AND_PROVISIONS, isDirect: false },
  { ...ONET, isDirect: false },
].map((item, index) => ({ ...item, id: String(index + 1) }));

export const MOCK_MATCHED_DOMAIN_APP_PANEL: OpenXAgentMatchedDomainAppPanelData = {
  title: 'Matches Details - Highest Scale',
  filters: [
    { id: 'format', label: 'Format', value: 'Banner' },
    { id: 'geography', label: 'Geography', value: 'United States' },
  ],
  stats: [
    { id: 'spend', icon: OpenXAgentHandCoinsIcon, label: '30 d Spend', value: '$4.82M' },
    { id: 'marketRequest', icon: TouchAppOutlined, label: 'Market Request', value: '13,8M/mo' },
    { id: 'relevance', icon: TrackChanges, label: 'Relevance', value: '92%' },
    { id: 'impressions', icon: PresentToAllOutlined, label: 'Impressions', value: '17.8M' },
    { id: 'averageCpm', icon: OpenXAgentHandCoinsIcon, label: '3P Average CPM', value: '$3,8M' },
    { id: 'viewability', icon: VisibilityOutlined, label: 'Viewability', value: '85%' },
    { id: 'bidRate', icon: AdsClickOutlined, label: 'Bid Rate', value: '75%' },
    { id: 'winRate', icon: EmojiEventsOutlined, label: 'Win Rate', value: '87%' },
  ],
  items: MOCK_DOMAIN_APPS,
};
